import { createApp } from 'vue'
import FontFavoritesApp from "../app/FontFavoritesApp.vue";
import AppUtil from "../app/utils/AppUtil";

import Rails from "@rails/ujs";
window.Rails = Rails;

import webase from "../app/model"
window.webase = webase
webase.utils.app = new AppUtil()

document.addEventListener('DOMContentLoaded', () => {
    const app = createApp(FontFavoritesApp)
    app.mount('#app')
})